import dayjs from "dayjs";
import { RRule } from "rrule";
import { ScheduledReportModel } from "./ScheduledReport.model";

export class ScheduledReport extends ScheduledReportModel {
    reportTypeText() {
        switch (this.reportType) {
            case "past_due_imminent_action":
                return "Past Due / Imminent Action";
            case "a_e_report":
                return "A & E Report";
            case "custom":
                return "Custom Report";
            default:
                return this.reportType;
        }
    }
    toRrule() {
        return RRule.fromString(this.frequency);
    }
    toText() {
        const rrule = this.toRrule();
        let rruleString = rrule.toText();

        // We normalize the displayed time ourselves, so strip any trailing
        // time phrase from RRule text to avoid malformed or duplicated output.
        if (rrule.options.freq !== RRule.MONTHLY) {
            rruleString = rruleString.replace(/\s+at\s+\d{1,2}(?::\d{2})?$/i, "").trim();
        }
        const time = dayjs()
            .set("hour", rrule.options.byhour ? rrule.options.byhour[0] : 0)
            .set("minute", rrule.options.byminute ? rrule.options.byminute[0] : 0);
        rruleString += ` at ${time.format("h:mm A")}`;

        return rruleString;
    }
}
